import moment from "moment";

const dateformat = "DD-MMM-YYYY";
const timeformat = "DD-MMM-YYYY HH:mm:ss";
const monthyearformat = "MMMM YYYY";
const yearonlyformat = "YYYY";

// const dateformat = store.state.sitesetting.date_format;
// const timeformat = store.state.timeformat;
// const monthyearformat = store.state.monthyearformat;
// const yearonlyformat = store.state.yearonlyformat;

export const formatDate = (date) => {

  if(date == null){
    return "..."
      }else{
  var m = moment(new Date(date), dateformat);
  var formatted = m.locale("en").format(dateformat);
  return formatted;
}};

export const formatDateTime = (date) => {
  var m = moment(new Date(date), timeformat);
  var formatted = m.locale("en").format(timeformat);
  return formatted;
};

export const isCurrentDate = (date) => {
  let current = format(new Date());
  let compareto = format(date);
  return moment(current).isSame(compareto, "day");
};

export const isPastCurrentDate = (date) => {
  let current = format(new Date());
  let compareto = format(date);
  return moment(current).isAfter(compareto, "day");
};

export const formatDateToMonthYear = (date) => {
  var m = moment(new Date(date), monthyearformat);
  var formatted = m.locale("en").format(monthyearformat);
  return formatted;
};

export const returnOnlyYear = (date) => {
  var m = moment(new Date(date), yearonlyformat);
  var formatted = m.locale("en").format(yearonlyformat);
  return formatted;
};

function format(date) {
  const format = "YYYY-MM-DD";
  var m = moment(new Date(date), format);
  var formatted = m.locale("en").format(format);
  return formatted;
}

/** Normalize API/picker values for DatePicker; null when unparseable */
export function normalizePickerDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  // vue-datepicker emits dayjs objects; moment(dayjs) loose-parses as today
  if (typeof value === "object" && typeof value.toDate === "function") {
    const d = value.toDate();
    return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
  }
  if (typeof value === "number" && Number.isFinite(value)) {
    const m = moment(value);
    return m.isValid() ? m.toDate() : null;
  }
  const m = moment(
    value,
    [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"],
    true
  );
  if (m.isValid()) return m.toDate();
  return null;
}

/** Normalize picker/API values to YYYY-MM-DD for order filters */
export function toApiDate(value, fallback) {
  const fb = fallback || moment().format("YYYY-MM-DD");
  if (value == null || value === "") return fb;
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return moment(value).format("YYYY-MM-DD");
  }
  const m = moment(
    value,
    [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"],
    true
  );
  if (m.isValid()) return m.format("YYYY-MM-DD");
  const loose = moment(value);
  return loose.isValid() ? loose.format("YYYY-MM-DD") : fb;
}
